import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useIntl } from 'react-intl';

import type { SmartRouteStage } from './useSmartRoute.ts';

export const SmartRouteProgress = ({
    stage,
    onCancel,
    onRetry,
}: {
    stage?: SmartRouteStage;
    onCancel: () => void;
    onRetry: () => void;
}) => {
    const intl = useIntl();
    if (!stage) {
        return null;
    }
    const message = (key: string) => intl.formatMessage({ id: `intl-msg:ordercom-cloud-frontend.smart-route.${key}` });
    const steps = ['preparing', 'calculating', 'preview'] as const;
    const active = stage === 'error' ? -1 : steps.indexOf(stage);
    return (
        <Dialog
            show
            bsSize='sm'
            title={message('title')}
            onClose={onCancel}
            body={
                <div className='display-flex flex-column gap-20' aria-live='polite'>
                    {stage === 'error' ? (
                        <div role='alert' className='alert alert-danger margin-0'>
                            {message('error')}
                        </div>
                    ) : (
                        <>
                            <div className='border rounded bg-lightest padding-25 text-center'>
                                <Spinner isInline />
                                <div className='text-bold margin-top-15'>{message('calculating')}</div>
                            </div>
                            <progress className='width-100pct' aria-label={message('title')} />
                            <ol className='list-unstyled margin-0'>
                                {steps.map((step, index) => (
                                    <li key={step} className='display-flex align-items-center gap-10 padding-y-5'>
                                        <span
                                            aria-hidden='true'
                                            className={`uikit-icon ${index < active ? 'icon-ok-sign text-color-success' : index === active ? 'icon-time text-color-primary' : 'icon-circle text-color-light'}`}
                                        />
                                        <span className={index === active ? 'text-bold' : 'text-color-dark'}>
                                            {message(step)}
                                        </span>
                                    </li>
                                ))}
                            </ol>
                        </>
                    )}
                </div>
            }
            footer={
                <div className='display-flex justify-content-end gap-10'>
                    <Button bsStyle='default' onClick={onCancel}>
                        {intl.formatMessage({ id: 'intl-msg:common-message.cancel' })}
                    </Button>
                    {stage === 'error' && (
                        <Button bsStyle='primary' onClick={onRetry}>
                            {intl.formatMessage({ id: 'intl-msg:common-message.error.generic.retry' })}
                        </Button>
                    )}
                </div>
            }
        />
    );
};
